import { ReactComponent as BottomDarkSVG } from "./bottom-bg.svg"

export default BottomDarkSVG